export default {
  loadingIndicator: {
    color: 'primary darken-2',
    size: 3
  }
}
